import Footer from '../../footer/Footer';
import Navbar from '../../navbar/Navbar';
import AboutLeftTab from '../../About/AboutLeftTab';


function HigherEducationCounsellingJuly30() {
    return (
        <div>
            <Navbar />
            <div className="graduate-admission pt-lg-5 pt-4 pb-70">
                <div className="container">
                    <div className="row">
                        <AboutLeftTab />

                        <div className="col-lg-8 ps-lg-4 order-1 order-lg-2">
                            <div className="col-lg-12 ps-lg-4">
                                <div className="how-to-apply">
                                    <h2 className='pb-2'>
                                        Higher Education Counselling by Career Bridge on 30 July,2025
                                    </h2>

                                    <div class="css-script-ads" >
                                    </div>
                                    <div class="spotlight-group">
                                        <div class="row">

                                            <div class="col-md-6 mb-3 mb-lg-4">
                                                <a class="spotlight" href="https://admin.swec.ac.in/assetsswec/img/higher-education-counselling/1000283298.jpg">
                                                    <img src="https://admin.swec.ac.in/assetsswec/img/higher-education-counselling/1000283298.jpg" loading="lazy" alt="Higher Education Counselling by Career Bridge" class="img-responsive center-block rounded-1" />
                                                </a>
                                            </div>
                                            <div class="col-md-6 mb-3 mb-lg-4">
                                                <a class="spotlight" href="https://admin.swec.ac.in/assetsswec/img/higher-education-counselling/1000283310.jpg">
                                                    <img src="https://admin.swec.ac.in/assetsswec/img/higher-education-counselling/1000283310.jpg" loading="lazy" alt="Higher Education Counselling by Career Bridge" class="img-responsive center-block rounded-1" />
                                                </a>
                                            </div>
                                            <div class="col-md-6 mb-3 mb-lg-4">
                                                <a class="spotlight" href="https://admin.swec.ac.in/assetsswec/img/higher-education-counselling/1000283316.jpg">
                                                    <img src="https://admin.swec.ac.in/assetsswec/img/higher-education-counselling/1000283316.jpg" loading="lazy" alt="Higher Education Counselling by Career Bridge" class="img-responsive center-block rounded-1" />
                                                </a>
                                            </div>
                                            <div class="col-md-6 mb-3 mb-lg-4">
                                                <a class="spotlight" href="https://admin.swec.ac.in/assetsswec/img/higher-education-counselling/1000283292.jpg">
                                                    <img src="https://admin.swec.ac.in/assetsswec/img/higher-education-counselling/1000283292.jpg" loading="lazy" alt="Higher Education Counselling by Career Bridge" class="img-responsive center-block rounded-1" />
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <Footer />
        </div>
    )
}

export default HigherEducationCounsellingJuly30
